import { useContext } from 'react';
import { AddressPickerContext } from './AddressPickerProvider';

export default function useAddressPickerContext() {
  const context = useContext(AddressPickerContext);
  if (!context) {
    throw new Error('useAddressPickerContext must be used within a AddressPickerProvider');
  }
  return context;
}
